import { Type } from '@angular/core';

import { ISPFieldTypeBase } from 'common/dynamic-form/types/field-type-base.class';
import {
  CodeControlWithValue,
  TextEditorControlWithValue,
  TypedControl,
} from 'common/dynamic-form/utils/form-preparing';

import { ISPConfigMapper } from './model/config-mapper.interface';

export interface FieldPayload {
  name: TypedControl['type'];
  component: Type<ISPFieldTypeBase>;
  module: Type<any>;
  mapper: ISPConfigMapper;
}

export const FIELD_LOADERS: Record<
  TypedControl['type'],
  {
    component: () => Promise<Type<ISPFieldTypeBase>>;
    module: () => Promise<Type<any>>;
    mapper: () => Promise<ISPConfigMapper>;
  }
> = {
  code: {
    component: () =>
      import('../../types/code/code.component').then(r => r.CodeFieldComponent),
    module: () =>
      import('../../types/code/code.module').then(r => r.CodeFieldModule),
    mapper: () =>
      import('../../types/code/code.utils').then(
        r => (control: CodeControlWithValue, field, state) =>
          r.getCodeConfig(control.control, field.field, state),
      ),
  },
  texteditor: {
    component: () =>
      import('../../types/texteditor/texteditor.component').then(
        r => r.TextEditorFieldComponent,
      ),
    module: () =>
      import('../../types/texteditor/texteditor.module').then(
        r => r.TextEditorFieldModule,
      ),
    mapper: () =>
      import('../../types/texteditor/texteditor.utils').then(
        r => (control: TextEditorControlWithValue, field, state) =>
          r.getTextEditorConfig(control.control, field.field, state),
      ),
  },
} as any;
